import React from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

export enum SpaceSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export type SpaceProps = {
  testID?: string
  size?: SpaceSize
}

const StyledView = styled(View)<{ size: SpaceProps['size'] }>`
  height: ${({ theme, size }) => {
    const base = theme.metrics.baseMargin
    const sizes: Record<SpaceSize, number> = { small: base / 2, medium: base, large: base * 2 }

    return sizes[size ?? SpaceSize.Medium]
  }}px;
`

export const Space: React.FC<SpaceProps> = ({ testID, size = SpaceSize.Medium }) => {
  return <StyledView testID={testID} size={size} />
}
